import React from 'react';

const HomeQuickServices = () => {
  return (
    <div className="flex flex-col gap-6 sm:gap-8 px-4 sm:px-8 md:px-12 lg:px-24 xl:px-40 2xl:px-64 py-10 sm:py-14">
      <p className="text-center font-nunito text-[24px] sm:text-[28px] md:text-[32px] font-semibold leading-[1.4]">
        Our Services
      </p>
      <p className="font-nunito text-[12px] sm:text-[12px] md:text-[14px] lg:text-[17px] leading-[1.8] text-justify">
        eSparse Matrix Solutions Private Limited is a Software agency in Pune. We will provide a one-stop solution for all customer IT service needs. We take care of everything from strategic concept software development, business analysis, digital marketing, to full-scale software development and online marketing — all in one place. Once you join with eSparse Matrix Solutions, you will never have to go anywhere else again.
      </p>
    </div>
  );
};

export default HomeQuickServices;
